import Typography from "@mui/material/Typography";
import React, { ChangeEvent, FC, ReactNode } from "react";
import FlexCenter from "shared/components/Layout/components/FlexCenter";
import { COLOR_GREY_9 } from "../../../theme/colors";
import { StyledMuiSwitch, StyledSwitchContainer } from "./styled";

type Props = {
  label?: ReactNode;
  value: boolean;
  onChange?: (checked: boolean) => void;
  trackColor?: string;
  disabled?: boolean;
};

const SecondarySwitch: FC<Props> = ({ trackColor, ...props }) => {
  const handleChange = (_: ChangeEvent<HTMLInputElement>, checked: boolean) => {
    props.onChange && props.onChange(checked);
  };

  return (
    <FlexCenter columnGap={1.5}>
      <StyledSwitchContainer>
        <StyledMuiSwitch
          disabled={props.disabled}
          checked={props.value}
          onChange={handleChange}
          trackColor={trackColor}
        />
      </StyledSwitchContainer>
      <Typography
        variant="bodyLMedium"
        color={COLOR_GREY_9}
        textTransform="uppercase"
      >
        {props.label}
      </Typography>
    </FlexCenter>
  );
};

export default SecondarySwitch;
